import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLang } from "@/i18n";
import { CATEGORIES } from "@/config";
import { Search, MapPin, CalendarDays, Users } from "lucide-react";

export default function QuickBookBar() {
  const { t, lang } = useLang();
  const nav = useNavigate();
  const [dest, setDest] = useState("");
  const [date, setDate] = useState("");
  const [pax, setPax] = useState(2);

  const search = (e) => {
    e.preventDefault();
    const q = new URLSearchParams();
    if (dest) q.set("cat", dest);
    if (date) q.set("date", date);
    if (pax) q.set("pax", pax);
    nav(`/tours?${q.toString()}`);
  };

  const fieldCls = "w-full bg-transparent outline-none text-[#F5F2EA] text-[15px] placeholder-[#A3A095]";

  return (
    <section data-testid="quickbook-section" className="relative z-20 max-w-[1200px] mx-auto px-6 md:px-12 -mt-16 md:-mt-20">
      <form
        onSubmit={search}
        className="bg-[#0A1210]/95 backdrop-blur-xl border border-[#C4A661]/25 shadow-[0_30px_80px_-30px_rgba(0,0,0,0.9)] p-6 md:p-8"
      >
        <p className="eyebrow mb-6">{t("quickbook.title")}</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[1.3fr_1fr_0.8fr_auto] gap-5 items-end">
          <label className="block border-b border-[#1E2B25] focus-within:border-[#C4A661] pb-3 transition-colors">
            <span className="flex items-center gap-2 text-[10px] tracking-[0.22em] uppercase text-[#A3A095] mb-2">
              <MapPin size={12} className="text-[#C4A661]" /> {t("quickbook.destination")}
            </span>
            <select
              data-testid="quickbook-destination"
              value={dest}
              onChange={(e) => setDest(e.target.value)}
              className={fieldCls}
            >
              <option value="" className="bg-[#0A1210]">{t("quickbook.any")}</option>
              {CATEGORIES.map((c) => (
                <option key={c.key} value={c.key} className="bg-[#0A1210]">
                  {lang === "es" ? c.es : c.en}
                </option>
              ))}
            </select>
          </label>
          <label className="block border-b border-[#1E2B25] focus-within:border-[#C4A661] pb-3 transition-colors">
            <span className="flex items-center gap-2 text-[10px] tracking-[0.22em] uppercase text-[#A3A095] mb-2">
              <CalendarDays size={12} className="text-[#C4A661]" /> {t("quickbook.date")}
            </span>
            <input
              data-testid="quickbook-date"
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              className={fieldCls}
            />
          </label>
          <label className="block border-b border-[#1E2B25] focus-within:border-[#C4A661] pb-3 transition-colors">
            <span className="flex items-center gap-2 text-[10px] tracking-[0.22em] uppercase text-[#A3A095] mb-2">
              <Users size={12} className="text-[#C4A661]" /> {t("quickbook.people")}
            </span>
            <input
              data-testid="quickbook-pax"
              type="number"
              min="1"
              value={pax}
              onChange={(e) => setPax(e.target.value)}
              className={fieldCls}
            />
          </label>
          <button data-testid="quickbook-search" type="submit" className="hc-btn-primary w-full lg:w-auto whitespace-nowrap">
            <Search size={14} className="mr-2" /> {t("quickbook.cta")}
          </button>
        </div>
      </form>
    </section>
  );
}
